import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { installSeo } from './services/seoClient'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import './assets/styles/mobile.scss'
import './assets/styles/theme.scss'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

// 滚动进场：元素进入视口后揭示一次，离场不回退，避免来回抖动。
// 刻意不用 IntersectionObserver —— 它在个别 WebView / 无头环境里存在但回调永不触发，
// 那会把整页内容永久留在 opacity:0。这里用 rAF 节流的位置检测，每页目标不过十几个，
// 开销可以忽略，且任何环境下都保证内容最终可见。
const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

const revealQueue = new Set()
let revealBound = false
let revealTicking = false

function revealNow(el) {
  el.classList.add('is-revealed')
  revealQueue.delete(el)
}

function sweepReveal() {
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0
  revealQueue.forEach(el => {
    const rect = el.getBoundingClientRect()
    // 进入视口下沿 94% 处即揭示，避免元素贴着边缘才动
    if (rect.top < viewportHeight * 0.94 && rect.bottom > 0) revealNow(el)
  })
}

function scheduleSweep() {
  if (revealTicking) return
  revealTicking = true
  // rAF 在后台标签页里不会触发（新标签打开链接就是这种情况）。
  // 只靠 rAF 复位节流锁的话，锁会永久卡住，之后所有滚动都失效。
  // 所以加一个定时器兜底，两者谁先到都能解锁并完成扫描。
  let done = false
  const run = () => {
    if (done) return
    done = true
    revealTicking = false
    sweepReveal()
  }
  window.requestAnimationFrame(run)
  window.setTimeout(run, 120)
}

function bindReveal() {
  if (revealBound) return
  revealBound = true
  window.addEventListener('scroll', scheduleSweep, { passive: true })
  window.addEventListener('resize', scheduleSweep, { passive: true })
  // 页面在后台加载时动效与 rAF 均被冻结，切回前台后补扫一次
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleSweep()
  })
}

Vue.directive('reveal', {
  inserted(el, binding) {
    // 要求减少动效时直接显示，不做任何位移
    if (prefersReducedMotion()) {
      el.classList.add('reveal', 'is-revealed')
      return
    }
    const delay = Number(binding.value)
    if (delay > 0) el.style.setProperty('--reveal-delay', `${delay}ms`)
    el.classList.add('reveal')
    revealQueue.add(el)
    bindReveal()
    scheduleSweep()
    // 兜底：布局稳定后再扫一次，防止首屏元素因图片撑高而被漏掉
    window.setTimeout(sweepReveal, 240)
  },
  unbind(el) {
    revealQueue.delete(el)
  }
})

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
axios.defaults.baseURL = 'http://shkjgw.shkjem.com/api/'
Vue.prototype.$http = axios

// 图片服务器地址
Vue.prototype.imgserver = 'http://shkjgw.shkjem.com/'

installSeo(router)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
